import CohortLinkVisualPreviewContent from '@cohort/components-xps/components/contents/apps/cohort/link/VisualPreviewContent';
import type {VisualPreviewProps} from '@cohort/merchants/apps';
import type {CohortLinkMediaStruct} from '@cohort/shared/apps/cohort/medias/link';

const CohortLinkVisualPreview: React.FC<VisualPreviewProps<CohortLinkMediaStruct>> = ({
  config,
  title,
  className,
}) => (
  <CohortLinkVisualPreviewContent imageSrc={config.imageSrc} title={title} className={className} />
);

export default CohortLinkVisualPreview;
